import React, { Fragment } from 'react'
import Paper from 'material-ui-legacy/Paper'
import Row from 'muicss/lib/react/row'
import Col from 'muicss/lib/react/col'

// Custom UI components
import errors from '../../lib/errors.js'
import LinearLoader from '../UI/LinearLoader'
import ErrorDialog from '../UI/ErrorDialog'

import QuotesManager from './QuotesManager'
import ActualsManager from './ActualsManager'
import ClientFacingQuote from './ClientFacingQuote'
import QuoteCostSummary from './QuoteCostSummary'
import InternalActual from './InternalActual'
import ActualCostSummary from './ActualCostSummary'

import Resource from '../../stores/resource'
const ProjectStore = Resource('projects')

/*
Props:
- projectId: Id of the project to quich the quotes belong
- quoteId: Id of a quote to be selected automatically (optional)
- actualId: Id of an actual to be selected automatically (optional)
- readOnly: Boolean(false): self-explanatory
*/
class QuotesPager extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      project: null,
      quote: null,
      actual: null,
      error: null,
      loading: true
    }
  }

  componentDidMount() {
    if (this.props.projectId) this._loadData()
  }

  _loadData = () => {
    this.setState({ loading: true })
    ProjectStore.findBy({ id: this.props.projectId }, [
      'agency',
      'client',
      'agencyProducer',
      'user',
      'quotes',
      'actuals'
    ])
      .then(result =>
        this.setState({
          project: result.data,
          loading: false
        })
      )
      .catch(error =>
        this.setState({ error: errors.unpack(error), loading: false })
      )
  }

  _quoteSelected = quote => this.setState({ quote })

  _actualSelected = actual => this.setState({ actual })

  _getIncludedCount = (includedName) => {
    const { project } = this.state
    if (!project || !project.included(includedName)) return 0
    return project.included(includedName).length
  }

  render() {
    const { readOnly, quoteId, actualId } = this.props
    const { project, quote, actual, error, loading } = this.state

    const quoteCount = this._getIncludedCount('quotes')
    const actualCount = this._getIncludedCount('actuals')
    const selectedQuoteId = quoteId || (quote ? quote.id : null)
    const selectedActualId = actualId || (actual ? actual.id : null)

    // Same with loading
    if (loading) return <LinearLoader />

    return (
      <section>
        <QuotesManager
          project={project}
          quoteId={selectedQuoteId}
          readOnly={readOnly}
          selectCallback={this._quoteSelected}
          refreshCallback={this._loadData}
        />
        {quoteCount > 0 && (
          <Row>
            <Col sm="12">
              <Paper style={{ padding: '20px' }}>
                {!quote && (
                  <section style={{ textAlign: 'center', color: 'gray' }}>
                    Click a quote above to view it
                  </section>
                )}
                {quote && (
                  <section>
                    <ClientFacingQuote project={project} quote={quote} />
                    <QuoteCostSummary quote={quote} />
                  </section>
                )}
              </Paper>
            </Col>
          </Row>
        )}

        {actualCount > 0 && (
          <Fragment>
            <ActualsManager
              project={project}
              actualId={selectedActualId}
              readOnly={readOnly}
              selectCallback={this._actualSelected}
              refreshCallback={this._loadData}
            />
            <Row>
              <Col sm="12">
                <Paper style={{ padding: '20px' }}>
                  {!actual && (
                    <section style={{ textAlign: 'center', color: 'gray' }}>
                      Click an actual above to view it
                    </section>
                  )}
                  {actual && (
                    <section>
                      <InternalActual project={project} actual={actual} />
                      <ActualCostSummary actual={actual} />
                    </section>
                  )}
                </Paper>
              </Col>
            </Row>
          </Fragment>
        )}

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={() => this.setState({ error: null })}
        >
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </section>
    )
  }
}

export default QuotesPager



// WEBPACK FOOTER //
// ./src/components/Quotes/QuotesPager.jsx